import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";

export default function ProfileInfo(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  return (
    <React.Fragment>
      <br />
      <form className={classes.center}>
        {/* <FormGroup row>
          <TextField
            type="text"
            label="ProfileName"
            value={props.Profile.ProfileName}
            multiline={false}
            //onChange={handleChangeFamilyGame}
            variant="outlined"
            className="select-input-general"
          />
          <TextField
            type="text"
            label="AlternateProfile"
            value={props.Profile.AlternateProfile}
            multiline={false}
            //onChange={handleChangeFamilyGame}
            variant="outlined"
            className="select-input-general"
          />

<TextField
            type="text"
            label="Notes"
            value={props.Profile.Notes}
            multiline={true}
            // onChange={handleChangeFamilyGame}
            variant="outlined"
            className="select-input-general"
          />
       
       <Button
            
            className="select-input-general "
            variant="contained"
            //onClick={handleFindParent}
            //startIcon={<SearchIcon />}
          >
            Save
          </Button>
        </FormGroup>
     
      */}
      </form>
    </React.Fragment>
  );
}
